<template>
  <b-container fluid>
    <h1>RC Bonus Calculation</h1>
    <b-container fluid v-if="optionsLoaded">
      <b-row>
        <b-col v-if="(isAdmin || isSRC) && countries.length > 1">
          <b-select v-model="country" class="mb-4">
            <b-select-option value="">Choose country...</b-select-option>
            <b-select-option v-for="c in countries" :key="c" :value="c">{{ c }}</b-select-option>
          </b-select>
        </b-col>
        <b-col>
          <b-select v-if="country" v-model="period" class="mb-4">
            <b-select-option v-for="value, key in dateOptions" :key="key" :value="key">{{ value }}</b-select-option>
          </b-select>
        </b-col>
      </b-row>
    </b-container>
    <rc-performance-data v-if="country && period" :key="country + '_' + period" :country="country" :period="period" bonus-only="true"></rc-performance-data>
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RcPerformanceData from '@/components/RcPerformanceData';

export default {
  name: 'RcBonusCalculation',
  components: {
    RcPerformanceData,
  },
  data() {
    return {
      country: '',
      urlParams: new URLSearchParams(window.location.search),
      optionsLoaded: false,
      period: '',
      // getCoordinatorUuid: "6d4045b8-e521-49d8-a8c6-f667dcceebfd", // for testing RC own login
    }
  },
  created() {
    this.getOptions();
    let todayDate = new Date(),
      currentYear = todayDate.getFullYear(),
      currentMonth = todayDate.getMonth();
    this.period = `${currentYear}${currentMonth < 6 ? 'H1' : 'H2'}`;
  },
  methods: {
    ...mapActions({
      GET_OPTIONS: "optionsList/GET_OPTIONS",
      GET_COORDINATORS: "coordinators/GET_COORDINATORS",
      GET_TEAMS: "teams/GET_TEAMS",
    }),
    async getOptions() {
      try {
        await this.GET_OPTIONS();
        await this.GET_COORDINATORS();
        await this.GET_TEAMS();

        if (this.getCoordinatorUuid) {
          this.$store.state.coordinators.coordinators.forEach(coord => {
            if (coord.uuid == this.getCoordinatorUuid) {
              this.country = coord.country;
            }
          });
        } else if (this.countries.length == 1) {
          this.country = this.countries[0];
        } else if (this.country) {
          this.setUrlParam('country', this.country);
        } else {
          this.deleteUrlParam('country');
        }
        this.optionsLoaded = true;
      } catch (err) {
        console.error(err);
      }
    },
    setUrlParam(param, value) {
      this.urlParams.set(param, value);
      window.history.replaceState({}, '', `${location.pathname}?${this.urlParams}`);
    },
    deleteUrlParam(param) {
      this.urlParams.delete(param);
      window.history.replaceState({}, '', `${location.pathname}?${this.urlParams}`);
    },
  },
  computed: {
    ...mapGetters({
      getCoordinatorUuid: "auth/getCoordinatorUuid",
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
    }),
    countries: {
      get() {
        return (this.isSRC && this.$store.state.teams.teams && this.$store.state.teams.teams.length > 0)
          ? [... new Set(this.$store.state.teams.teams.map(team => team.country))]
          : this.$store.state.optionsList.countries.sort();
      }
    },
    dateOptions: {
      get() {
        let todayDate = new Date(),
          currentYear = todayDate.getFullYear(),
          currentMonth = todayDate.getMonth(),
          options = {};
        for (let y = 2020; y < currentYear; y++) {
          options[`${y}H1`] = `${y} (January – June)`;
          options[`${y}H2`] = `${y} (July – December)`;
        }
        options[`${currentYear}H1`] = `${currentYear} (January – June)`;
        if (currentMonth >= 6) {
          options[`${currentYear}H2`] = `${currentYear} (July – December)`;
        }
        return options;
      },
    },
  },
};
</script>
